import getEditorData from '../../Common/getEditorData';
import saveEditorData from '../../Common/saveEditorData';
import router from '../../../router/routes';
import destroyEditorData from '../../Common/destroyEditorData';

export default {
    namespaced: true,

    state: {
        deleteModal: false,
        name: '',
        postData: [],
        professionId: 0,
        route: '',
        deletable: false
    },

    getters: {
        postData(state) {
            return {
                name: state.name
            };
        },

        route(state) {
            if (state.professionId) {
                return '/api/specialty/edit/' + state.professionId;
            } else {
                return '/api/specialty/create';
            }
        }
    },

    mutations: {
        setProfessionId(state, value) {
            state.professionId = value;
        },

        setName(state, value) {
            state.name = value;
        },

        setDeletable(state, value) {
            state.deletable = value;
        },

        toggleDeleteModal(state, value) {
            state.deleteModal = value;
        }
    },

    actions: {
        getData({ commit, getters, state }) {
            commit('overlay/toggle', true, { root: true });
            commit('setProfessionId', router.currentRoute.params.id ? router.currentRoute.params.id : 0);

            if (state.professionId) {
                getEditorData(getters.route).then((response) => {
                    const profession = response.data.data.profession;
                    commit('setName', profession.name);
                    commit('setDeletable', profession.deletable);
                    commit('overlay/toggle', false, { root: true });
                });
            } else {
                commit('setName', '');
                commit('overlay/toggle', false, { root: true });
            }
        },

        saveData({ getters, commit }) {
            saveEditorData('profession', getters.route, getters.postData)
                .then((professionId) => {
                    if (router.currentRoute.name === 'ProfessionEdit') {
                        commit('overlay/toggle', false, { root: true });
                    } else {
                        router.push('/specialty/edit/' + professionId);
                    }
                })
                .catch(() => {
                });
        },

        destroyData({ state }) {
            destroyEditorData('/api/specialty/delete/' + state.professionId)
                .then(() => {
                })
                .catch(() => {
                });
        }
    }
};
